/**
 * Library-Filter-Optionen — Single-Source für Typ/Status-Labels + den
 * AssetTypeFilter-Typ. Liegt bewusst in lib/ (nicht im FilterBar-Component),
 * damit FilterBar UND ActiveFilters dieselben Labels teilen, ohne dass eine
 * Komponente Nicht-Komponenten exportiert (react-refresh/Konvention).
 */
import type { AssetStatusFilter } from '../../shared/asset-constants';
import type { StatsState } from '../../shared/asset-stats-types';

export type AssetTypeFilter = 'all' | 'img' | 'video' | 'pdf' | 'logo';

// Type-Chip-Map: jeder Chip kennt seinen `byType`-Key (oder null für "Alle"
// = total). FilterBar-Render mapped chip → count via stats.
export const TYPE_CHIPS: { value: AssetTypeFilter; label: string; statsKey: keyof StatsState extends never ? never : 'img' | 'video' | 'pdf' | 'logo' | null }[] = [
  { value: 'all', label: 'Alle', statsKey: null },
  { value: 'img', label: 'Bilder', statsKey: 'img' },
  { value: 'video', label: 'Videos', statsKey: 'video' },
  { value: 'pdf', label: 'PDF', statsKey: 'pdf' },
  { value: 'logo', label: 'Logos', statsKey: 'logo' },
];

// Status-Filter-Optionen (Default 'approved' = „Freigegeben").
// Redesign S2 (2026-10-10, Entscheid 6): Wording Freigegeben / Entwurf /
// Archiviert app-weit; Werte approved/draft/archived bleiben.
export const STATUS_OPTIONS: { value: AssetStatusFilter; label: string }[] = [
  { value: 'approved', label: 'Freigegeben' },
  { value: 'draft', label: 'Entwurf' },
  { value: 'archived', label: 'Archiviert' },
  { value: 'all', label: 'Alle Status' },
];
